<template lang="pug">
  include ../mixins
  div.position--relative#cards-response
    ui-preloader(v-if="isLoad" loader-color='loader-wrapper__bg--light')
    row.ma--bottom_md(v-if="!isResponse" space="sm-xl" ref="card")
      slot(name="cards" ref="card")
    renderer(
      v-if="isResponse"
      :result="response"
      class-render='g-row g-row--space_sm-xxl'
    )
    row.ma--top_md(justify="center")
      cell(cols="12 9-lg 8-xxl")
        pagination(
          v-if="count > perPage"
          class-wrapper="pagination__wrapper--light"
          :is-scroll="false"
          :current='page'
          :total='count'
          :perPage='perPage'
          :is-add-more="isCombinePagination"
          @add="isAddPage = $event"
          @page-changed="page = $event; getCards($event)"
        )
</template>

<script>
import {
  articlesListResource,
  promoListResource,
  massMediaArticlesListResource,
} from '@services/common.service.js'
import { prefixLanguage } from '@helpers/url'

export default {
  name: 'request-component',
  components: {
    'ui-preloader': () => import('@app/UiElements/UiPreloader'),
    pagination: () => import('@app/UiElements/Pagination'),
  },
  props: {
    slug: String,
    resource: String,
    pagination: Object,
    category: {
      type: String,
      required: false,
    },
    isCombinePagination: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      sendData: {},
      response: '',
      resourceObject: {
        articles: articlesListResource,
        stock: promoListResource,
        media: massMediaArticlesListResource,
      },
      count: this.pagination.count,
      page: this.pagination.page,
      perPage: this.pagination.perPage,
      isAddPage: false,
      isFirstAdd: true,
      firstCards: '',
      isLoad: false,
      isResponse: false,
    }
  },
  created() {
    window.onpopstate = async () => {
      window.location.reload()
    }
  },
  mounted() {
    console.log('request component')
    if (true === this.isCombinePagination) {
      this.getFirstCards()
    }
  },
  methods: {
    getCards() {
      this.isLoad = true
      return this.resourceObject[this.resource].execute({
        page: this.page,
        category: this.category,
      })
        .then(res => {
          this.handleResponse(res)
        })
    },
    handleResponse({ data, meta }) {
      if (true === this.isCombinePagination) {
        if (true === this.isAddPage) {
          if (true === this.isFirstAdd) this.response = this.firstCards
          this.response += data
          this.isFirstAdd = false
        } else {
          this.isFirstAdd = false
          this.response = data
          this.firstCards = ''
        }
      } else this.response = data
      this.page = meta.page
      this.count = meta.count
      this.perPage = meta.perPage
      this.pushHistory()
      this.isResponse = true

      // const url = location.href
      // location.href = "#cards-response"
      // history.replaceState(null,null,url)
      const cardsRow = document.getElementById('h1-title')
      let top = 0
      if (cardsRow) {
        top = cardsRow.offsetTop
      }
      console.log(cardsRow)
      console.log(top, 'top')
      // cardsRow.scrollIntoView()
      window.scroll(0, top)

      this.isLoad = false
    },
    getFirstCards() {
      console.log('getFirstCards')
      this.firstCards = this.$refs.card.innerHTML
      console.log(this.$refs.card.innerHTML)
    },
    pushHistory() {
      let path = ''
      if ("media" !== this.resourceObject) {
        if (1 < this.page) path = `${prefixLanguage()}/${this.slug}${`${this.category }/` || ''}page/${this.page}/`
        else path = `${prefixLanguage()}/${this.slug}`
      } else {
        if (1 < this.page) path = `${prefixLanguage()}/${this.slug} || ''}page/${this.page}/`
        else path = `${prefixLanguage()}/${this.slug}`
      }
      
      window.history.pushState(null, null, path)
    },
  },
}
</script>
